import React, { useEffect, useState } from 'react';
import GenericModal from '~/components/GenericModal/GenericModal';
import Spinner from '~/components/Spinner/Spinner';
import {
  AuditBuildingResult,
  getNotificationAuditBatch
} from '~/api/notificationAudit';
import classes from './NotificationAudit.module.css';

interface IProps {
  batchUuid: string | null;
  onClose: () => void;
}

const appName = (url: string | null) =>
  url ? url.replace(/^https?:\/\//, '').replace(/\/.*$/, '') : '—';

// Every building a multi-building post went to. Reuses the push-result endpoint.
const NotificationAuditBuildingsModal = ({ batchUuid, onClose }: IProps) => {
  const [buildings, setBuildings] = useState<AuditBuildingResult[] | null>(
    null
  );
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!batchUuid) return;
    setBuildings(null);
    setError(null);
    getNotificationAuditBatch(batchUuid)
      .then(({ data }) =>
        setBuildings(
          [...data.buildings].sort((a, b) =>
            (a.buildingName || '').localeCompare(b.buildingName || '')
          )
        )
      )
      .catch((e) =>
        setError(
          e?.response?.data?.message ||
            e?.message ||
            'Could not load buildings.'
        )
      );
  }, [batchUuid]);

  let content: React.ReactNode = (
    <div style={{ textAlign: 'center', padding: 24 }}>
      <Spinner />
    </div>
  );
  if (error) content = <p className={classes.bad}>{error}</p>;
  if (buildings) {
    content = (
      <div className={classes.modalBody}>
        <p className={classes.subtle}>{buildings.length} buildings</p>
        <table className={classes.table}>
          <thead>
            <tr>
              <th>#</th>
              <th>Building</th>
              <th>App</th>
            </tr>
          </thead>
          <tbody>
            {buildings.map((b, i) => (
              <tr key={b.building}>
                <td className={classes.subtle}>{i + 1}</td>
                <td>{b.buildingName || b.building}</td>
                <td className={classes.subtle}>{appName(b.appUrl)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <GenericModal
      showModal={!!batchUuid}
      title='Buildings in this post'
      content={content}
      hideActionButton
      cancelOverride='Close'
      onChange={(show) => !show && onClose()}
      width='640px'
    />
  );
};

export default NotificationAuditBuildingsModal;
